"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrimmerHandle = void 0;

var _useDraggable3 = require("../../hooks/useDraggable");

var _atoms = require("../../atoms");

var _react = _interopRequireWildcard(require("react"));

require("./TrimmerControls.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Vars
var SIDE_HANDLE_WIDTH = 32.0; // Trimmer Handle

var TrimmerHandle = function TrimmerHandle(_ref) {
  var cn = _ref.cn,
      name = _ref.name,
      icon = _ref.icon,
      children = _ref.children,
      xOffset = _ref.xOffset,
      yOffset = _ref.yOffset,
      extraWidth = _ref.extraWidth,
      onRepositionX = _ref.onRepositionX,
      onRepositionY = _ref.onRepositionY,
      trackPosition = _ref.trackPosition,
      leftHandlePosition = _ref.leftHandlePosition,
      middleHandlePosition = _ref.middleHandlePosition,
      rightHandlePosition = _ref.rightHandlePosition,
      addtlStyles = _ref.addtlStyles,
      maxWidth = _ref.maxWidth;
  var handleDrag = (0, _react.useCallback)(function (_ref2) {
    var x = _ref2.x,
        y = _ref2.y,
        movementX = _ref2.movementX,
        movementY = _ref2.movementY;
    var massagedX = x;

    switch (name) {
      case "left":
        {
          // Prevent left handle from moving beyond start of track
          if (movementX <= 0 && leftHandlePosition.current.right + movementX < trackPosition.current.left) {
            massagedX = null;
          } // Prevent left handle from moving beyond end of middle handle
          else if (movementX >= 0 && leftHandlePosition.current.right + movementX > middleHandlePosition.current.right) {
            massagedX = null;
          }

          break;
        }

      case "middle":
        {
          // Prevent left handle from moving beyond start of track
          if (movementX <= 0 && leftHandlePosition.current.right + movementX < trackPosition.current.left) {
            massagedX = null;
          } // Prevent right handle from moving beyond end of track
          else if (movementX >= 0 && rightHandlePosition.current.left + movementX > trackPosition.current.right) {
            massagedX = null;
          }

          break;
        }

      case "right":
        {
          // Prevent right handle from moving beyond start of middle handle
          if (movementX <= 0 && rightHandlePosition.current.left + movementX < middleHandlePosition.current.left) {
            massagedX = null;
          } // Prevent right handle from moving beyond end of track
          else if (movementX >= 0 && rightHandlePosition.current.left + movementX > trackPosition.current.right) {
            massagedX = null;
          }

          break;
        }

      default:
        break;
    }

    return {
      x: massagedX,
      y: 0
    };
  }, []);
  var handleReposition = (0, _react.useCallback)(function (_ref3) {
    var x = _ref3.x,
        y = _ref3.y;

    if (typeof onRepositionX === "function") {
      onRepositionX(x);
    }

    if (typeof onRepositionY === "function") {
      onRepositionY(y);
    }
  }, []);

  var _useDraggable = (0, _useDraggable3.useDraggable)(handleDrag, handleReposition, xOffset, yOffset, extraWidth, maxWidth),
      _useDraggable2 = _slicedToArray(_useDraggable, 2),
      ref = _useDraggable2[0],
      pressed = _useDraggable2[1];

  var coverStyles = name === "middle" ? null : addtlStyles;
  var containerStyles = name === "middle" ? addtlStyles : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "".concat(cn, " draggable"),
    style: containerStyles
  }, children, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "cover",
    style: coverStyles
  }), icon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "16",
    type: icon,
    color: _atoms.Color.White2
  }));
};

exports.TrimmerHandle = TrimmerHandle;